import { Injectable } from "@angular/core";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class ServiceService {
  constructor(private http: HttpClient) {}

  // async loadData(
  //   paramsObj: { [key: string]: any },
  //   endpoint: string = ""
  // ): Promise<{ result: any; fullQuery: string }> {
  //   const accountIds: string[] = Array.isArray(paramsObj.account_ids)
  //     ? paramsObj.account_ids
  //     : [];

  //   // If multiple accountIds, call separately for each
  //   if (accountIds.length > 1) {
  //     const { account_ids: _ignore, ...rest } = paramsObj;

  //     const calls = accountIds.map((id) => {
  //       let httpParams = new HttpParams();

  //       Object.entries({ ...rest, account_ids: id }).forEach(([key, val]) => {
  //         if (val === undefined || val === null) return;
  //         if (typeof val === "string") {
  //           if (val.trim() === "") return;
  //           httpParams = httpParams.set(key, val);
  //         } else {
  //           httpParams = httpParams.set(key, String(val));
  //         }
  //       });

  //       const url = `https://rscrijtl30.execute-api.ap-south-1.amazonaws.com/dev/admin/bills${endpoint}`;
  //       return this.http.get<any>(url, { params: httpParams }).toPromise();
  //     });

  //     const responses = await Promise.all(calls);

  //     let totalFinalCost = 0;
  //     const allAccounts: any[] = [];

  //     responses.forEach((res) => {
  //       totalFinalCost +=
  //         res?.response?.all_account_cost_summary?.final_cost ?? 0;
  //       allAccounts.push(...(res?.response?.accounts ?? []));
  //     });

  //     const merged = {
  //       response: {
  //         all_account_cost_summary: { final_cost: totalFinalCost },
  //         accounts: allAccounts,
  //       },
  //     };

  //     // Just return a combined query string for logging/debugging
  //     const fullQuery = `account_ids=${accountIds.join("&account_ids=")}`;

  //     return {
  //       result: merged,
  //       fullQuery: `${endpoint}${fullQuery ? "?" + fullQuery : ""}`,
  //     };
  //   }

  //   // Single account_id or no account_ids
  //   let httpParams = new HttpParams();
  //   Object.entries(paramsObj).forEach(([key, val]) => {
  //     if (val === undefined || val === null) return;
  //     if (typeof val === "string") {
  //       if (val.trim() === "") return;
  //       httpParams = httpParams.set(key, val);
  //     } else if (Array.isArray(val)) {
  //       // Only allow single item arrays for account_ids
  //       if (key === "account_ids" && val.length > 1) return;
  //       val.forEach((v: string) => {
  //         httpParams = httpParams.append(key, v);
  //       });
  //     } else {
  //       httpParams = httpParams.set(key, String(val));
  //     }
  //   });
  //   let headers: HttpHeaders | undefined = undefined;
    
  //   const typeValue = paramsObj.type;
  //   if (typeValue) {
  //     const now = new Date();
  //     const formattedDateTime = now.toISOString(); // Example: 2025-09-22T11:30:45.123Z

  //     headers = new HttpHeaders({
  //       "X-Bypass-Cache": `${typeValue}_${formattedDateTime}`,
  //     });
  //   }
  //   const url = `https://rscrijtl30.execute-api.ap-south-1.amazonaws.com/dev/admin/bills${endpoint}`;
  //   const result = await this.http
  //     .get<any>(url, { params: httpParams, headers })
  //     .toPromise();

  //   return {
  //     result,
  //     fullQuery: httpParams.toString(),
  //   };
  // }

async loadData(
  paramsObj: { [key: string]: any },
  endpoint: string = ""
): Promise<{ result: any; fullQuery: string }> {

  let accountIds: string[] = [];

  const rawIds = paramsObj?.account_ids;

  if (Array.isArray(rawIds)) {
    // ✅ Already an array
    accountIds = rawIds
      .filter(id => id !== null && id !== undefined && id !== "")
      .map(id => String(id).trim());
  } else if (typeof rawIds === "string" && rawIds.trim() !== "") {
    // ✅ Comma-separated string → split into array
    accountIds = rawIds
      .split(",")
      .map(id => id.trim())
      .filter(id => id !== "");
  }

  if (paramsObj.type == 'all_account_monthly') {
    // Combine account IDs into a single comma-separated string
    const accountIdsString = accountIds.join(",");

    // Exclude original account_ids from paramsObj
    const { account_ids: _ignore, ...rest } = paramsObj;

    let httpParams = new HttpParams();

    // Set all params including combined account_ids
    Object.entries({ ...rest, account_ids: accountIdsString }).forEach(
      ([key, val]) => {
        if (val === undefined || val === null || val === "") return;
        httpParams = httpParams.set(key, String(val)); // force string
      }
    );

    const url = `https://rscrijtl30.execute-api.ap-south-1.amazonaws.com/dev/admin/bills${endpoint}`;
    try {
      const res = await this.http.get<any>(url, { params: httpParams }).toPromise();
      return {
        result: res,
        fullQuery: `${endpoint}?account_ids=${accountIdsString}`,
      };
    } catch (err) {
      throw err;
    }
  }
  else{
      let httpParams = new HttpParams();

  Object.entries(paramsObj).forEach(([key, val]) => {
    if (val === undefined || val === null) return;
    if (Array.isArray(val)) {
      val.forEach(v => {
        if (v !== null && v !== undefined && v !== "") {
          httpParams = httpParams.append(key, String(v)); // force string
        }
      });
    } else {
      httpParams = httpParams.set(key, String(val)); // force string
    }
  });

  let headers: HttpHeaders | undefined;
  if (paramsObj.type) {
    headers = new HttpHeaders({
      "X-Bypass-Cache": `${paramsObj.type}_${new Date().toISOString()}`,
    });
  }

  const url = `https://rscrijtl30.execute-api.ap-south-1.amazonaws.com/dev/admin/bills${endpoint}`;
  const result = await this.http.get<any>(url, { params: httpParams, headers }).toPromise();

  return {
    result,
    fullQuery: httpParams.toString(),
  };
  }

  // Fallback for single account or no account_ids

}

async loadSummary(paramsObj: { [key: string]: any }) {
    let httpParams = new HttpParams();

    Object.entries(paramsObj).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        httpParams = httpParams.set(key, value as string);
      }
    });

    const url =
      "https://rscrijtl30.execute-api.ap-south-1.amazonaws.com/dev/admin/bills/summary";

    const result = await this.http.get(url, { params: httpParams }).toPromise();
    return { result, fullQuery: httpParams.toString() };
  }

  async loadhighestCost(paramsObj: { [key: string]: any }) {
    let httpParams = new HttpParams();

    Object.entries(paramsObj).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        httpParams = httpParams.set(key, value as string);
      }
    });

    const url =
      "https://rscrijtl30.execute-api.ap-south-1.amazonaws.com/dev/admin/bills/highlights";

    const result = await this.http.get(url, { params: httpParams }).toPromise();
    return { result, fullQuery: httpParams.toString() };
  }

async downloadAllToCSV(paramsObj: any) {
  let httpParams = new HttpParams();

  Object.entries(paramsObj).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      httpParams = httpParams.set(key, value as string);
    }
  });

  const url = 'https://rscrijtl30.execute-api.ap-south-1.amazonaws.com/dev/admin/bills';

  console.log('API URL:', url);
  console.log('HTTP Params:', httpParams.toString());

  try {
    const result: any = await this.http
      .get(url, { params: httpParams })
      .toPromise();

    console.log('API Response:', result);

    if (result?.s === '1' || result?.status === '1') {
      const preSignedUrl: string = result.response.download_url;

      const newTab = window.open(preSignedUrl.trim(), '_blank');

      if (!newTab) {
        console.error('Popup blocked or URL invalid');
      }
    } else {
      throw new Error('Download failed');
    }

    return result;
  } catch (error) {
    console.error('Download error:', error);
    throw error;
  }
}

async exportPDF(paramsObj: { [key: string]: any }){
let httpParams = new HttpParams();

    Object.entries(paramsObj).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        httpParams = httpParams.set(key, value as string);
      }
    });

    const url =
      "https://rscrijtl30.execute-api.ap-south-1.amazonaws.com/dev/admin/bills";

    const result = await this.http.get(url, { params: httpParams }).toPromise();
    return { result, fullQuery: httpParams.toString() };
}

/**
 * Calls POST /admin/bills/dailyBilling with only
 * { accountId, startDate, endDate, groupBy } sent in the request body.
 * Any other keys on paramsObj (e.g. type, used only for the cache-bypass
 * header) are intentionally excluded from the body.
 */
async loadDailyBilling(
  paramsObj: { [key: string]: any }
): Promise<{ result: any; fullQuery: string }> {
  const allowedKeys = ["accountId", "startDate", "endDate", "groupBy"];
  const body: { [key: string]: any } = {};

  allowedKeys.forEach((key) => {
    const val = paramsObj[key];
    if (val === undefined || val === null || val === "") return;
    body[key] = val;
  });

  let headers: HttpHeaders | undefined;
  if (paramsObj.type) {
    headers = new HttpHeaders({
      "X-Bypass-Cache": `${paramsObj.type}_${new Date().toISOString()}`,
    });
  }

  const url = `https://rscrijtl30.execute-api.ap-south-1.amazonaws.com/dev/admin/bills/dailyBilling`;

  try {
    const result = await this.http
      .post<any>(url, body, { headers })
      .toPromise();

    return {
      result,
      fullQuery: JSON.stringify(body),
    };
  } catch (err) {
    throw err;
  }
}

}
